// extracted by mini-css-extract-plugin
export default {"preparation":"preparation_preparation__XYyyQ","preparation__button":"preparation_preparation__button__w-MkF","preparation__loader":"preparation_preparation__loader__JZA2k"};